import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { ReactComponent as CheckIcon } from '../../../../../../assets/icons/check_purple_icon.svg';
import { sendOtpVoucher } from "store/forms/actions";
import { getActionsVoucher } from "store/appTrack/actions";
import { Spin } from "antd";

const SupplierActionList = (props) =>{
    const [isReady, setIsReady] = useState(false);
    const [error, setError] = useState(null);
    const dispatch = useDispatch();
    const view = useSelector(state => state.appTrack.permissions.view);
    const edit = useSelector(state => state.appTrack.permissions.edit);
    const cancel = useSelector(state => state.appTrack.permissions.cancel);
    const reserve = useSelector(state => state.appTrack.permissions.reserve);
    const redeem = useSelector(state => state.appTrack.permissions.redeem);
    const redeemOverwrite = useSelector(state => state.appTrack.permissions.redeemOverwrite);
    const release = useSelector(state => state.appTrack.permissions.release);

    useEffect(() => {
      let mounted = true;

      const initializeActions = () => {
          dispatch(getActionsVoucher(props?.voucherInfo?.voucher?.code))
              .then(() => {
                  if (!mounted) return;
                  
                  if (typeof view !== 'undefined' && 
                      typeof edit !== 'undefined' && 
                      typeof cancel !== 'undefined') {
                      setIsReady(true);
                  }
              })
              .catch((error) => {
                  if (!mounted) return;
                  console.error('Failed to initialize actions:', error);
                  setError(error);
              });
        setIsReady(true);
      };
      
      initializeActions();

      // cleanup to prevent mem leaks
      return () => {
          mounted = false;
      };
    }, [dispatch, props.id, view, edit, cancel]);

    // Error state
    if (error) {
      return (
          <div className="popover-container">
              <div className="popover-item" style={{ color: 'red', padding: '12px' }}>
                  Failed to load actions
              </div>
          </div>
      );
    }

    // loading state ...
    if (!isReady) {
        return (
            <div id={`action-list-for-${props.id}`} className="popover-container">
                <div className="popover-item" style={{ textAlign: 'center', padding: '12px' }}>
                    <Spin size="small" />
                </div>
            </div>
        );
    }
    const onReserve = () => {
        const params = {
            voucherCode: props?.voucherInfo?.voucher?.code,
            vatId: props?.legalVat
        }
        dispatch(sendOtpVoucher(params));
        props.setOtpModal(true);
        props.setOpen(false);
    }

    const onRedeem = () => {
        props.setOpenReedemModal(true);
        props.setOpen(false);
    }

    const onRedeemOverwrite = () => {
        props.setOpenRedeemOverwriteModal(true);
        props.setOpen(false);
    }

    const onRelease = () => {
        props.setGenericModal(true);
        props.setOpen(false);
    }

    return(
        <div id={`action-list-for-${props.id}`} className="popover-container">
            { reserve ? <div id="action-button-reserve" className={`popover-item ${props.disableAction ? 'disabled-action' : ''}`} onClick={()=>onReserve()}>Δέσμευση <CheckIcon className="check"/></div> : null }
            { redeem ? <div id="action-button-redeem" className="popover-item" onClick={()=> onRedeem()}>Αίτημα Πληρωμής <CheckIcon className="check"/></div> : null }
            { redeemOverwrite ? <div id="action-button-redeemOverwrite" className="popover-item" onClick={()=> onRedeemOverwrite()}>Διόρθωση Αρχείων Πληρωμής <CheckIcon className="check"/></div> : null }
            { release ? <div id="action-button-release" className="popover-item" onClick={()=>onRelease()}>Αποδέσμευση <CheckIcon className="check"/></div> : null }
        </div>
    )
}

export default SupplierActionList;